



































































import Vue from "vue";
import { Parameter } from "@/types";
import { locStr, validateEmail } from "@/utilities";
import * as Actions from "@/actions";
import { dataStore } from "@/main";

export default Vue.extend({
    name: "MangoFpParameters",
    components: {},
    data() {
        return {
            data4Edit: [] as Parameter[],
            parameters: dataStore.state.parameters,
            confirmDisabled: true,
        };
    },
    async mounted() {
        this.confirmDisabled = true;
        await Actions.getAllOptions();
        this.confirmDisabled = false;
    },
    watch: {
        parameters() {
            for (let i = 0; i < this.parameters.length; i++) {
                this.data4Edit.splice(i, 1, { ...this.parameters[i] });
            }
        },
    },
    methods: {
        locStr: function(key: string): string {
            return locStr(key);
        },

        getNewParam4Edit() {
            return {
                value: "",
                type: "string",
                name: "",
            };
        },

        async saveParameters() {
            const notValidParam = this.data4Edit.find(elem => elem.errorMsg);
            if (notValidParam) {
                return false;
            }

            const changedParams = this.data4Edit.filter((param, i) => {
                return param.value !== this.parameters[i].value;
            });

            if (changedParams.length) {
                this.confirmDisabled = true;
                await Actions.updateOptions(changedParams);
                this.confirmDisabled = false;
            }
        },

        onFocus() {
            Actions.clearGeneralMessage();
        },
        validateEmailElem(emailParam: Parameter) {
            if (!validateEmail(emailParam.value)) {
                emailParam.errorMsg = locStr("Email format is not correct");
                return;
            }
            emailParam.errorMsg = "";
        },
        clearEmailElemErrorMsg(emailParam: Parameter) {
            this.onFocus();
            emailParam.errorMsg = "";
        },
    },
});
